import { render } from "./Signup.vue?vue&type=template&id=6c7e37a4&scoped=true"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import "./Signup.vue?vue&type=style&index=0&id=6c7e37a4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Nebula PC\\Coding\\web-projects\\snowchron\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7e37a4"]])

export default __exports__